<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Dollar from "@/assets/media/svg/icons/Shopping/Dollar.svg";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import SalesRoi from "@/view/components/dashboard/SalesRoi.vue";
import OreRecommendations from "@/view/components/dashboard/OreRecommendations.vue";
import Recommendations from "@/view/components/dashboard/Recommendations.vue";
import { getRecommendations } from "@/api/analytics.js";
import { getTotalSales } from "@/api/dashboard.js";
import { getLocations } from "@/api/locations";
import { getIndex, setLocation,getData } from "@/utils.js";
import swal from "sweetalert";
import moment from "moment";
const startOfMonth = moment()
  // .subtract(1, "months")
  .startOf("month")
  .format("YYYY-MM-DD");

const endOfMonth = moment()
  // .subtract(1, "months")
  .endOf("month")
  .format("YYYY-MM-DD");

export default {
  name: "marketing-analytics",
  metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Default Title',
      // all titles will be injected into this template
      titleTemplate: '%s | My Awesome Webapp'
    },
  components: {
    VueCtkDateTimePicker,
    SalesRoi,
    OreRecommendations,
    Recommendations
  },
  data() {
    return {
      msg: null,
      dtpicker: { start: startOfMonth, end: endOfMonth },
      dt: "",
      loading: true,
      items: [],
      snackbar: false,
      text: "",
      timeout: 2000,
      sales: 0.0,
      isLoaded: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      selected_location: null,
      locations: [],
      selectedItems: [],
      maxDisplay: 1,
      searchTerm: null,
      locationsCopy: [],
      locationsOptions: [],
      startOfMonth,
      endOfMonth,
      firstLoadDone: false
    };
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Recommendations" }]);
    
    this.$store.commit("setLocationVisibile", true);
    const response = await getLocations();
    if (response) {
      this.locations = response;
      // Check localStorage
      let local_storage_selected_location = JSON.parse(
        localStorage.getItem("selected_location")
      );
      console.log(
        "local_storage_selected_location",
        local_storage_selected_location
      );
      if (local_storage_selected_location) {
        this.selected_location = local_storage_selected_location;
        setLocation(this.selected_location);
        this.selectedItems.push(local_storage_selected_location.id);
      } else {
        let selected = null;
        let index = getIndex(response);
        selected = response[index];
        console.log("selected", selected);
        this.selected_location = selected;
        setLocation(this.selected_location);
        this.selectedItems.push(selected.id);
      }

      this.setLocations();
      setTimeout(() => {
        this.onSearch();
      }, 2000);
    }
  },
  computed: {
    dollar() {
      return Dollar;
    },
    likesAllItems() {
      return this.selectedItems.length === this.locationsOptions.length;
    },
    likesSomeItem() {
      return this.selectedItems.length > 0 && !this.likesAllItems;
    },
    icon() {
      if (this.likesAllItems) return "mdi-close-box";
      if (this.likesSomeItem) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    }
  },
  watch: {
    $route: {
        immediate: true,
        handler(to, from) {
            document.title = to.meta.title || 'Aben';
        }
    },
    selected_location() {
      let elems = document.getElementsByClassName("multiselect__content");
      if (elems[0]) {
        // elems[0].setAttribute("class", "democlass");
        elems[0].style.paddingLeft = "0px";
      }
    },
    dtpicker(newVal) {
      if (newVal == undefined) {
        let last365 = moment().subtract(1, 'years')
        last365 = last365.format("YYYY-MM-DD");
        let today = moment()
        today = today.format("YYYY-MM-DD");

        this.dtpicker = { start: last365, end: today };
      }
    }
  },
  methods: {
    async onSearch() {
      // console.log(this.selected_location);
      // let location_id =
      //   this.selected_location && this.selected_location.id
      //     ? this.selected_location.id
      //     : null;
      // if (!location_id) {
      //   swal("Select a Location", "No locations detected");
      //   return;
      // }

      if (!this.firstLoadDone ){ 
        this.firstLoadDone = true

        let current = new Date()
        let enddate = `${current.getFullYear()}-${current.getMonth() + 1}-${current.getDate()}`
        let startdate = `${current.getFullYear() - 1}-${current.getMonth() + 1}-${current.getDate()}`
        
        this.dtpicker.start = startdate // this set the value of date picker //initial first load set date range
        this.dtpicker.end = enddate
      }

      if (this.selectedItems.length == 0) {
        swal("No locations detected", "Please select at least one location");
        return;
      }
      console.log("this.selectedItems", this.selectedItems);
      setLocation(this.selected_location);
      this.loading = true;
      const payload = JSON.parse(
        JSON.stringify({
          start_date: this.dtpicker.start,
          end_date: this.dtpicker.end,
          location_ids: this.selectedItems
        })
      );
      // console.log(payload);
      this.items = await getRecommendations(payload);
      // console.log(this.items);
      this.items =this.items.sort(function(a,b){
      return  new Date(b.analysis_end_date) -new Date(a.analysis_end_date)
      })      
      this.sales = await getTotalSales(payload, true);
      // console.log(this.sales);
      if (this.items) {
        this.text = "Loading results";
      } else {
        this.text = "No results found";
      }
      this.snackbar = true;
      setTimeout(() => {
        this.loading = false;
      }, 2000);
      this.isLoaded = true;
    },
    customLabel({ name, street }) {
      return `${name} – ${street}`;
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllItems) {
          this.selectedItems = [];
        } else {
          let data = [];
          for (let i = 0; i < this.locationsOptions.length; i++) {
            let item = this.locationsOptions[i];
            data.push(item.value);
          }
          this.selectedItems = data;
        }
      });
    },
    setLocations() {
      this.locationsOptions = [
        ...this.locations.map(list => {
          return {
            value: list.id,
            text: `${list.name} ${list.full_address}`,
            name: `${list.name.replace(list.full_address, '')}`,
            full_address: list.full_address
          };
        })
      ];
      this.locationsCopy = [...this.locationsOptions];
    },
    filterLocations() {
      if (!this.searchTerm || this.locationsOptions.length == 0) {
        this.locationsOptions = this.locationsCopy;
      }
      this.locationsOptions = this.locationsOptions.filter(item => {
        return (
          item.text.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1
        );
      });
    },
    filterLocationsBlur(vl){
      this.searchTerm = null
      this.filterLocations()
    },
     whenDtClosed(){
      if(this.dtpicker.end == null && this.dtpicker.start != null) {
        this.dtpicker.end = this.dtpicker.start
      }
    },
  }
};
</script>

<template>
  <v-app class="bg-transparent">
    <v-main>
      <div
        class="subheader py-2 py-lg-4 d-flex align-items-center justify-content-center"
      >
        <div class="mr-2" style="width:300px">
          <VueCtkDateTimePicker
            v-model="dtpicker"
            format="YYYY-MM-DD"
            formatted="ll"
            label="Select date range"
            range
            id="mydtpicker"
            @is-hidden="whenDtClosed()"
          />
        </div>
        <div class="mr-2 mt-6" style="width: 350px;">
          <v-select
            v-model="selectedItems"
            :items="locationsOptions"
            label="Location"
            multiple
            required
            dense
            outlined
            background-color="#ffffff"
            height="42"
          >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content>
                  <v-text-field
                    v-model="searchTerm"
                    placeholder="Search"
                    @input="filterLocations"
                    @blur="filterLocationsBlur"
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
              <v-list-item ripple @click="toggle">
                <v-list-item-action>
                  <v-icon
                    :color="selectedItems.length > 0 ? 'indigo darken-4' : ''"
                  > {{ icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Select All
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template
              v-if="selectedItems.length > 1"
              v-slot:selection="{ item, index }"
            >
              <span v-if="index === maxDisplay">
                {{ selectedItems.length }} locations selected
              </span>
            </template>
            <template slot="item" slot-scope="{ item, attrs, on }">
              <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                <v-list-item-action>
                  <v-checkbox
                    :ripple="false"
                    :input-value="active"
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ item.full_address }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>
        </div>
        <div class="ml-2">
          <v-btn
            depressed
            color="primary"
            id="myBtn"
            @click="onSearch"
            :loading="loading"
            :disabled="loading"
          >
            <v-icon> mdi-magnify </v-icon>
          </v-btn>
        </div>
      </div>
      <div class="content-box">
        <sales-roi v-if="isLoaded" :total_sales="sales.total_sales"></sales-roi>
      </div>
      <div class="mt-5">
        <OreRecommendations
          v-if="isLoaded"
          :item="this.dtpicker"
          :start_date="startOfMonth"
          :end_date="endOfMonth"
        >
        </OreRecommendations>
      </div>
      <div class="mt-5">
        <Recommendations v-if="isLoaded" :items="items"></Recommendations>
      </div>
      <v-snackbar v-model="snackbar" :timeout="timeout">
        {{ text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <v-overlay :value="loading">
        <div class="text-center">
          <p>Loading ...</p>
          <v-progress-circular indeterminate size="30"></v-progress-circular>
        </div>
      </v-overlay>
    </v-main>
  </v-app>
</template>

<style src="@/assets/css/vue-multiselect.min.css"></style>
<style>
.font-weight-1-8rem {
  font-size: 1.8rem;
  font-weight: 900;
}
.font-weight-2-3rem {
  font-size: 2.3rem;
  font-weight: 900;
}
.font-weight-100 {
  font-weight: 100;
}

.status-container {
  border-radius: 0.2rem;
  line-height: 32px;
  font-size: 0.875rem;
  font-weight: 600;
  opacity: 0.8;
}
.status-container-orange {
  background-color: ##fff2d6;
}

.desc {
  font-size: 15px;
  font-weight: normal;
  font-family: "Poppins";
  line-height: 25px;
}
.box {
  /* border-top: #ccc 1px solid;
  border-right: #ccc 1px solid;
  border-bottom: #777 1px solid;
  border-left: #777 1px solid; */
  border: #cccccc ridge 1px;
  border-radius: 10px;
}
.subheader {
  background: #e9eaf3 !important;
}
.aside-fixed.subheader-fixed .subheader {
  left: 200px;
}
.aside-minimize.subheader-fixed .subheader {
  left: 70px;
}

.content-box {
  margin-top: 40px;
}
@media only screen and (max-width: 768px) {
  .content-box {
    margin-top: 0px;
  }
}

.location_address {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.54);
}

.v-text-field--outlined >>> fieldset {
  border: 1px solid rgba(0, 0, 0, 0.2);
}

.v-list {
  max-width: 100%;
}

.v-menu__content {
  max-width: 300px !important;
  /* border: blue solid 2px; */
}
</style>
